module.exports = __webpack_public_path__ + "img/data-empty.aa876a20.png";